import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import CustomTable from '../../components/Table';
import { Link } from 'react-router-dom';
import ReactDatePicker from 'react-datepicker';
import OrganizationTalkModal from '../../components/modal/OrganizationTalkModal';
import OrderTalkModal from '../../components/modal/OrderTalkModal';
import ChargeTalkModal from '../../components/modal/ChargeTalkModal';
import Pagination from '../../components/Pagination';

interface tabType {
  id: number;
  tab: string;
}
interface cashListType {
  date: string;
  count: string;
  cash: string;
  type: string;
}

const dateTabContent = [
  {
    id: 0,
    tab: '오늘',
  },
  {
    id: 1,
    tab: '이번주',
  },
  {
    id: 2,
    tab: '조회기간',
  },
];
const searchTypeTabContent = [
  {
    id: 0,
    tab: '전체',
  },
  {
    id: 1,
    tab: '사용',
  },
  {
    id: 2,
    tab: '충전',
  },
];
const useTabs = (initialTabs: tabType[]) => {
  const [contentIndex, setContentIndex] = useState<number>(0);

  const activateTab = (index: number) => {
    setContentIndex(index);
  };
  return {
    contentItem: initialTabs[contentIndex],
    contentChange: activateTab,
    activeIndex: contentIndex,
  };
};

const NotificationHistory = () => {
  const [storeName, setStoreName] = useState<string>('');

  const [storeCash, setStoreCash] = useState<number>(0);
  const [channelId, setChannelId] = useState<string>('');

  const [startDate, setStartDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date>(new Date());
  const { contentItem: dateContentItem, contentChange: dateContentChange } =
    useTabs(dateTabContent);
  const { contentItem: searchTypeContentItem, contentChange: searchTypeContentChange } =
    useTabs(searchTypeTabContent);

  const [innerWidth, setInnerWidth] = useState<number>(0);

  const [visibleOrganization, setVisibleOrganization] = useState<boolean>(false);
  const [visibleOrder, setVisibleOrder] = useState<boolean>(false);
  const [visibleCharge, setVisibleCharge] = useState<boolean>(false);

  // 현재 페이지
  const [currentPage, setCurrentPage] = useState<number>(1);
  // 당일 매출건수의 페이지 개수
  const [pageCount, setPageCount] = useState<number>(4);

  const onChange_storeName = (e: any) => {
    setStoreName(e.target.value);
  };

  const pressStartDate = async (date: Date) => {
    setStartDate(date);
  };
  const pressEndDate = async (date: Date) => {
    setEndDate(date);
  };

  const openDetailModal = (type: string) => {
    if (type === '단체알림톡') setVisibleOrganization(true);
    else if (type === '주문') setVisibleOrder(true);
    else setVisibleCharge(true);
  };

  useEffect(() => {
    const getInnerWidth = () => {
      setInnerWidth(window.innerWidth);
    };

    window.addEventListener('resize', getInnerWidth);

    return () => {
      window.removeEventListener('resize', getInnerWidth);
    };
  });

  //테이블 헤더
  const tableHeader = ['날짜', '발송건수', '사용캐시', '분류', '상세보기'];
  const mobileTableHeader = ['날짜', '발송건수', '사용캐시', '분류', ''];
  const renderTableItem = () => {
    const historyList = [
      {
        date: '2024.01.05',
        count: 5 + '건',
        cash: '-100캐시',
        type: '단체알림톡',
      },
      {
        date: '2024.02.05',
        count: 15 + '건',
        cash: '+1000캐시',
        type: '충전',
      },
      {
        date: '2022.02.05',
        count: 2 + '건',
        cash: '-300캐시',
        type: '주문',
      },
    ];
    return (
      <>
        {historyList.map((data: cashListType, index: number) => (
          <tr key={index} className="webTableWrap">
            <td>{data.date}</td>
            <td>{data.count}</td>
            <td>{data.cash}</td>
            <td>{data.type}</td>
            {innerWidth > 900 ? (
              <td>
                <button onClick={() => openDetailModal(data.type)}>상세보기</button>
              </td>
            ) : (
              <td>
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_arrow_right_gray.svg`}
                  width={28}
                  height={28}
                  alt="right"
                  onClick={() => openDetailModal(data.type)}
                />
              </td>
            )}
          </tr>
        ))}
      </>
    );
  };

  return (
    <>
      <Style>
        <div className="rightContentWrap">
          <h1>BEHIND 알림톡 조회</h1>
          <div className="title">
            <input
              value={storeName}
              placeholder="매장명을 검색해주세요"
              onChange={onChange_storeName}
            />
            <button className="searchButton">검색</button>
          </div>
          <div className="statusWrap">
            <div className="statusBox">
              <h5>잔여캐시</h5>
              <h3>{storeCash} 캐시</h3>
            </div>
            <div className="statusBox">
              <h5>독립채널</h5>
              <h3>채널아이디: {channelId}</h3>
            </div>
          </div>
          <div className="tabWrap">
            <div className="tabContainer">
              <div className="tabContent">
                {dateTabContent.map((section, index) => (
                  <button
                    key={'dateButtons-' + index.toString()}
                    onClick={() => dateContentChange(index)}
                    className={dateContentItem.id === section.id ? 'tab active' : 'tab'}>
                    <h2>{section.tab}</h2>
                  </button>
                ))}
              </div>
              <div className="calendarWrap">
                <label htmlFor="startDatePicker" className="calendarContainer">
                  <ReactDatePicker
                    id={'startDatePicker'}
                    className="datePicker"
                    selected={startDate}
                    onChange={(update: any) => pressStartDate(update)}
                    dateFormat="yyyy-MM-dd"
                    locale="ko"
                    minDate={new Date()}
                    disabledKeyboardNavigation={true}
                    onFocus={(e) => {
                      e.preventDefault();
                      e.target.blur();
                    }}
                  />
                  <div className="calendar">
                    <img src={`${process.env.PUBLIC_URL}/svg/ic_calendar.svg`} alt="달력아이콘" />
                  </div>
                </label>
                <h4>~</h4>
                <label htmlFor="endDatePicker" className="calendarContainer">
                  <ReactDatePicker
                    id={'endDatePicker'}
                    className="datePicker"
                    selected={endDate}
                    onChange={(update: any) => pressEndDate(update)}
                    dateFormat="yyyy-MM-dd"
                    locale="ko"
                    minDate={startDate}
                    disabledKeyboardNavigation={true}
                    onFocus={(e) => {
                      e.preventDefault();
                      e.target.blur();
                    }}
                  />
                  <div className="calendar">
                    <img src={`${process.env.PUBLIC_URL}/svg/ic_calendar.svg`} alt="달력아이콘" />
                  </div>
                </label>
              </div>
            </div>
            <div className="searchTypeWrap">
              <div className="tabContent">
                {searchTypeTabContent.map((section, index) => (
                  <button
                    key={'searchTypeButtons-' + index.toString()}
                    onClick={() => searchTypeContentChange(index)}
                    className={searchTypeContentItem.id === section.id ? 'tab active' : 'tab'}>
                    <h2>{section.tab}</h2>
                  </button>
                ))}
              </div>
              <button className="searchButton">조회</button>
            </div>
          </div>
          {/* <div className="notice">
            <h2>
              조회한 기간동안 사용한 캐시는 <span>000캐시 이며,</span> 잔여 캐시는
              <strong> 000캐시 입니다</strong>
            </h2>
            <Link to="/marketing/notificationRefund">
              <button>
                <p>환불신청</p>
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_arrow_right_red.svg`}
                  width="20px"
                  height="20px"
                  alt="더보기 화살표"
                />
              </button>
            </Link>
          </div> */}
          <CustomTable
            tableHeader={innerWidth > 900 ? tableHeader : mobileTableHeader}
            renderTableItem={renderTableItem}
            type="noneborder"
          />
          <div className="paginationWrap">
            <Pagination
              pageCount={pageCount}
              forcePage={currentPage - 1}
              handlePageClick={() => {}}
            />
          </div>
        </div>
      </Style>
      <OrganizationTalkModal isVisible={visibleOrganization} setVisible={setVisibleOrganization} />
      <OrderTalkModal isVisible={visibleOrder} setVisible={setVisibleOrder} />
      <ChargeTalkModal isVisible={visibleCharge} setVisible={setVisibleCharge} />
    </>
  );
};

export default NotificationHistory;

const Style = styled.div`
  .rightContentWrap {
    width: 100%;
    height: 100vh;
    background: #ffffff;
    padding: 6% 10%;
  }
  h1 {
    padding-bottom: 30px;
  }

  .title {
    display: flex;
    align-items: center;
    input {
      width: 100%;
      border: none;
      border-bottom: 1px solid #cecece;
      padding: 10px;
    }
    input:focus {
      border-radius: 5px 0 0 5px;
      outline: 1px solid #333333;
    }
    .searchButton {
      border-radius: 5px;
      border: none;
      background: #333333;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      color: #ffffff;
      white-space: nowrap;
      margin-left: -2px;
      padding: 12px 20px;
    }
  }

  .statusWrap {
    display: flex;
    align-items: center;
    padding: 40px 0;
    gap: 10px;

    .statusBox {
      width: 30%;
      border: 1px solid #cecece;
      background: #fcfcfc;
      padding: 12px 20px;

      h5 {
        font-weight: 400;
      }
      h3 {
        padding-top: 10px;
        font-weight: 500;
      }
    }
  }

  /* tabWrap */
  .tabWrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding-bottom: 24px;
  }

  /* tabContainer */
  .tabContainer {
    display: flex;
    align-items: flex-start;
  }

  /* tabContent */
  .tabContent {
    display: flex;
    margin-right: 10px;

    .tab {
      flex: 1;
      min-width: 90px;
      margin: -1px;
      padding: 3px;
      background: #fff;
      border: 1px solid #cecece;

      h2 {
        padding: 0;
        font-size: 16px;
        font-weight: 500;
        color: #a7a7a7;
        line-height: 28px;
      }
    }
    .tab.active {
      border: 1.5px solid #000;
      z-index: 1;
      h2 {
        color: #000;
      }
    }
    .tab:nth-child(1) {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    .tab:nth-child(3) {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  /* calendarContainer */
  .calendarWrap {
    display: flex;
    align-items: center;
    gap: 10px;

    h4 {
      color: #a7a7a7;
      font-weight: 400;
    }
    .calendarContainer {
      flex: 1;
      position: relative;
      border: 1px solid #cecece;
      padding: 2px 0;
      margin: -1px 0;
      border-radius: 5px;
      cursor: pointer;
      background: #fff;

      .calendar {
        position: absolute;
        right: 20px;
        top: 7px;
      }
    }
  }
  .datePicker {
    width: 100%;
    display: flex;
    align-items: center;
    border: none;
    padding: 5px 16px;
    border-radius: 5px;
    margin: -1px 0;
    color: #a7a7a7;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    cursor: pointer;
    letter-spacing: 0.5px;
    outline: none;

    h4 {
      font-size: 16px;
      font-weight: 400;
      color: #a7a7a7;
    }
    input {
      display: none;
    }
  }

  /* searchTypeWrap */
  .searchTypeWrap {
    width: 100%;
    display: flex;
    margin-left: auto;

    .searchButton {
      padding: 6px 50px;
      background: #000;
      color: #fff;
      border-radius: 4px;
      outline: none;
      border: none;
      font-size: 16px;
      font-weight: 500;
      white-space: nowrap;
    }
  }

  /* notice */
  .notice {
    display: flex;
    align-items: center;
    margin: 23px 0;

    h2 {
      font-size: 18px;
      font-weight: 400;
      color: #a7a7a7;
    }
    span {
      font-weight: 600;
      color: #237ce4;
    }
    strong {
      font-weight: 600;
      color: #000;
    }

    button {
      width: 100%;
      margin-left: 25%;
      padding: 5px 6px 5px 18px;
      display: flex;
      align-items: center;
      background: none;
      outline: none;
      border: 1px solid #ff5757;
      border-radius: 6px;

      p {
        margin-right: 4px;
        font-size: 16px;
        font-weight: 500;
        color: #ff5757;
      }
    }
  }

  ul {
    margin-top: 30px;
  }
  li {
    margin: 0 6px;
    a {
      border: none;
      padding: 10px 12px;
      font-size: 16px;
      color: #a7a7a7;
      font-weight: 400;
      width: 100%;
    }
  }
  .active {
    margin: 0 6px;
    a {
      background: none;
      color: #000000;
      font-weight: 600;
    }
  }

  @media (max-width: 1200px) {
    h1 {
      margin-bottom: 20px !important;
    }
    .tabContainer {
      margin-bottom: 0;
    }
  }
  @media (max-width: 900px) {
    .tabContainer {
      flex-direction: column;
      width: 100%;
    }
    .tabWrap .tabContent {
      width: 100%;
      margin-bottom: 10px;
    }
    .calendarWrap {
      min-width: 100%;
      img {
        width: 16px;
      }
    }
    .searchTypeWrap {
      .tab {
        min-width: auto;
      }
      .searchButton {
        margin-bottom: 10px;
        padding: 12px;
        min-width: 80px;
      }
    }

    .notice {
      margin: 12px 0 0 0;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;

      button {
        margin: 0 0 18px 0;
      }
    }
    ul {
      margin-top: 16px;
    }
  }

  /* table */
  .nonborder thead tr {
    font-size: 14px;
  }
  .nonborder tbody td {
    font-size: 14px;
    padding: 8px 6px;

    img {
      width: 16px;
      cursor: pointer;
    }
  }
  .nonborder tbody td:nth-child(1) {
    font-size: 12px;
  }

  // 전체
  .react-datepicker-popper {
    z-index: 1060;
  }
  .react-datepicker {
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    border: 1px solid #333333;
  }
  // 헤더
  .react-datepicker__header {
    background: #efefef;
    border-bottom: 1px solid #333333;
    border-radius: 10px 10px 0 0;
  }
  // 현재연월
  .react-datepicker__current-month {
    color: #000000;
  }
  // 요일
  .react-datepicker__day-name {
    width: 28px;
    color: #000000;
    font-weight: 500;
  }
  // 일요일
  .react-datepicker__day-name:nth-child(1) {
    color: #ff7e7e;
  }
  // 토요일
  .react-datepicker__day-name:nth-child(7) {
    color: #67a4ff;
  }

  // 날짜
  .react-datepicker__day {
    width: 28px;
    height: 28px;
    border-radius: 5px;
    font-weight: 400;
  }
  // 선택불가
  .react-datepicker__day--disabled {
    color: #cecece !important;
    pointer-events: none;
  }

  // 일요일
  .react-datepicker__day:nth-child(1) {
    color: #ff7e7e;
  }
  // 토요일
  .react-datepicker__day:nth-child(7) {
    color: #67a4ff;
  }

  // 범위
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    background: #efefef;
    border: 1px solid #333333;
    color: #000000 !important;
  }
  // 현재
  .react-datepicker__day--today {
    border: 1px solid #333333 !important;
    color: #000000;
    background: #ffffff;
  }

  // 말꼬리
  .react-datepicker__triangle {
    display: none;
  }
  // 위치
  .react-datepicker-popper {
    padding: 10px 0 0 0;
  }

  // outside
  .react-datepicker__day--outside-month {
    background: #fff !important;
    border: none;
  }
  .react-datepicker__week {
    display: flex;
    align-items: center;
  }
  // 범위 시작일
  .react-datepicker__day--range-start {
    background: #333333 !important;
    border: 1px solid #333333 !important;
    color: #ffffff !important;
    font-weight: 500;
  }
  // 범위 종료일
  .react-datepicker__day--range-end {
    background: #333333 !important;
    border: 1px solid #333333 !important;
    color: #ffffff !important;
    font-weight: 500;
  }
`;
